import { useEffect, useState } from 'react'

const numberParser = (number: number) => {
  return number < 10 ? `0${number}` : number
}

export const useTimer = (min = 0, sec = 0, isStarted = false) => {
  const [minutes, setMinutes] = useState<number>(min)
  const [seconds, setSeconds] = useState<number>(sec)
  const [isCountdownEnd, setIsCountdownEnd] = useState<boolean>(false)

  useEffect(() => {
    if (!isStarted) {
      return
    }

    if (isCountdownEnd) {
      setIsCountdownEnd(() => false)
    }

    const countdown = setInterval(() => {
      if (seconds > 0) {
        setSeconds(prev => prev - 1)
      }

      if (seconds !== 0) {
        return
      }

      if (minutes === 0) {
        clearInterval(countdown)
        setIsCountdownEnd(() => true)
        setMinutes(min)
        setSeconds(sec)
      } else {
        setMinutes(prev => prev - 1)
        setSeconds(59)
      }
    }, 1000)

    return () => clearInterval(countdown)
  }, [minutes, seconds, isStarted, min, sec, isCountdownEnd])

  return {
    minutes: numberParser(minutes),
    seconds: numberParser(seconds),
    isCountdownEnd,
  }
}
